import classNames from "classnames";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/Button/Button.tsx";
import { BaseClickableIcon } from "../../../../components/Icon/BaseClickableIcon.tsx";
import { ContentDownloadDialog } from "../../ContentDownload/ContentDownloadDialog.tsx";
import { useAddAssetsToTag } from "../../hooks/useAddAssetsToTag.ts";
import { useBoardAssets } from "../../hooks/useBoardAssets.ts";
import { useDeleteAssetOnBoard } from "../../hooks/useDeleteAssetOnBoard.ts";
import { useFavoriteTagUuid } from "../../hooks/useFavoriteTagUuid.ts";
import { usePurchaseAndDownload } from "../../hooks/usePurchaseAndDownload.ts";
import { useRemoveAssetsFromTag } from "../../hooks/useRemoveAssetsFromTag.ts";
import { selectedGridAssetsUuidStore } from "../../stores/selectedGridAssetsUuidStore.ts";
export const BulkActionsStripe = () => {
  const { selectedGridAssetsUuid } = selectedGridAssetsUuidStore.useState();
  const favoriteTagUuid = useFavoriteTagUuid();

  const { mutate: addAssetsToTag } = useAddAssetsToTag({
    assetUuids: selectedGridAssetsUuid,
  });
  const { mutate: removeAssetsFromTag } = useRemoveAssetsFromTag({
    assetUuids: selectedGridAssetsUuid,
  });

  const { assets: boardAssets } = useBoardAssets();
  const allSelectedAssetsAreFavorites = selectedGridAssetsUuidStore.useState(
    (s) =>
      s.selectedGridAssetsUuid.every(
        (uuid) =>
          boardAssets?.find((asset) => asset.uuid === uuid)?.is_in_favorite,
      ),
  );
  const someSelectedAssetsNotPurchased = selectedGridAssetsUuidStore.useState(
    (s) =>
      s.selectedGridAssetsUuid.some(
        (uuid) =>
          boardAssets?.find((asset) => asset.uuid === uuid)?.content
            .purchased_at === null,
      ),
  );

  const {
    mutate: purchaseAndDownload,
    isLoading: isLoadingPurchaseAndDownload,
  } = usePurchaseAndDownload({
    assetUuids: selectedGridAssetsUuid,
    contentUuids: selectedGridAssetsUuid.map(
      (uuid) =>
        boardAssets?.find((asset) => asset.uuid === uuid)?.content.uuid ?? "",
    ),
  });

  const deleteAssets = useDeleteAssetOnBoard();

  const [isUnfolded, setIsUnfolded] = useState(false);
  useEffect(() => {
    if (selectedGridAssetsUuid.length > 0) {
      setIsUnfolded(true);
    } else {
      setIsUnfolded(false);
    }
  }, [selectedGridAssetsUuid, setIsUnfolded]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <ContentDownloadDialog
        isOpen={isDialogOpen}
        onOpenChange={(open) => {
          setIsDialogOpen(open);
        }}
        assetUuids={selectedGridAssetsUuid}
      />
      <div className="w-full flex-row-center z-20">
        <div className="fixed bottom-600">
          <div
            className={classNames(
              "transition-transform duration-300 ease-out",
              isUnfolded ? "" : "translate-y-[calc(100%+26px)]",
              "pb-400",
            )}
          >
            <div className="flex-row items-center px-150 py-150 gap-200 rounded-300 shadow-100 bg-surface-primary-rest">
              <Button
                variant="tertiary"
                onClick={() => {
                  selectedGridAssetsUuidStore.resetSelection();
                }}
              >
                Clear selection ({selectedGridAssetsUuid.length})
              </Button>
              <div className="bg-primary h-500 w-025" />
              <BaseClickableIcon
                name="Heart"
                tooltip={{ side: "top", content: "Add to favorites" }}
                iconClassName={
                  allSelectedAssetsAreFavorites
                    ? "fill-error-rest stroke-error-rest"
                    : ""
                }
                onClick={() => {
                  if (allSelectedAssetsAreFavorites) {
                    removeAssetsFromTag(favoriteTagUuid);
                  } else {
                    addAssetsToTag(favoriteTagUuid);
                  }
                }}
              />
              <BaseClickableIcon
                name="Archive"
                tooltip={{ side: "top", content: "Archive" }}
                onClick={() => {
                  deleteAssets.mutate({
                    uuids: selectedGridAssetsUuid,
                  });
                  selectedGridAssetsUuidStore.resetSelection();
                }}
              />
              <Button
                iconName="Download"
                onClick={() => {
                  if (someSelectedAssetsNotPurchased) {
                    setIsDialogOpen(true);
                  } else {
                    purchaseAndDownload();
                  }
                }}
                loading={isLoadingPurchaseAndDownload}
              >
                Download
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
